module.exports = __webpack_public_path__ + "img/qz-per.73acd38a.png";